import { init, identify, PlatformName, setPageview } from '@cbhq/client-analytics';
import { useEffect } from 'react';
import { useTrackingPreference, TrackingCategory } from '@coinbase/cookie-manager';
import { getDeviceId } from '@/app/utils/analytics/getDeviceId';
import { getIsLocalDev } from '@/app/utils/analytics/events';

export function useInitCBAnalytics() {
  const { consent } = useTrackingPreference();

  useEffect(() => {
    // Prevent execution on server side
    if (typeof window === 'undefined') {
      return;
    }

    if (getIsLocalDev()) {
      return;
    }

    const deviceId = getDeviceId();

    const isFunctionalConsentAllowed = consent.includes(TrackingCategory.FUNCTIONAL);
    if (isFunctionalConsentAllowed) {
      try {
        init({
          amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_KEY ?? '',
          batchEventsThreshold: 5,
          batchMetricsPeriod: 5,
          isProd: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production',
          platform: PlatformName.web,
          projectName: 'verified_pools',
          version: process.env.NEXT_PUBLIC_APP_VERSION ?? '1.0.0',
          showDebugLogging: process.env.NODE_ENV === 'development',
          onError: (error) => {
            console.warn('Analytics error:', error);
          },
        });

        // Initial identify with just deviceId
        identify({ deviceId });

        // Allows VVA to send page data on events + metrics
        setPageview({
          isEnabled: true,
        });
      } catch (error) {
        console.warn('Analytics init error:', error);
      }
    }
  }, [consent]);
}
